import { Formatter } from '../formatter';
export const zipcodeFormatter: Formatter = {
    format(zipcode: string): string {
        const cleanedZip = zipcode.replace(/\s/g, '');

        if (/^[1-9]\d{3}[a-zA-Z]{2}$/.test(cleanedZip)) {
            return `${cleanedZip.substring(0, 4)}${cleanedZip.substring(4).toUpperCase()}`;
        }

        return zipcode;
    },
    formatDisplay(zipcode: string): string {
        const cleanedZip = zipcode.replace(/\s/g, '');

        if (/^[1-9]\d{3}[a-zA-Z]{2}$/.test(cleanedZip)) {
            return `${cleanedZip.substring(0, 4)} ${cleanedZip.substring(4).toUpperCase()}`;
        }

        return zipcode;
    }
};
